import { render } from "./ServerPager.vue?vue&type=template&id=23943f7e"
import script from "./ServerPager.vue?vue&type=script&lang=js"
export * from "./ServerPager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__